// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { get } from 'lodash'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import { i18n } from '../../index'
import StationPage from '../station/StationPage'
import FeelingMeterQuestionsForm from './FeelingMeterQuestionForm'
import css from './feelingsMeterQuestions.css'
import { deleteQuestionMutation, getStationQuestions, updateQuestionMutation } from './feelingsMeterQuestionsQueries'

function StationFeelingsMeterQuestionsPage() {
  const toggleActiveStatus = (question, onMutate) => {
    const data = {
      active: !question.active,
    }
    const variables = {
      id: question.id,
      data,
    }
    onMutate({
      variables,
    })
  }

  return (
    <StationPage title={i18n.t('admin.stations.title.feelingsMeterQuestions')}>
      {({ station }) => (
        <div>
          <FeelingMeterQuestionsForm station={station} />
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={css.tableHeading}>{i18n.t('admin.feelingsMeterQuestions.question')}</TableCell>
                  <TableCell />
                  <TableCell className={css.tableHeading} padding='checkbox'>
                    {i18n.t('admin.feelingsMeterQuestions.active')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <Query
                query={getStationQuestions}
                variables={{
                  stationId: station.id,
                }}
              >
                {({ loading, error, data }) => {
                  const questions = get(data, 'getStationQuestions', [])
                  return (
                    <TableBody>
                      {questions.map((q) => (
                        <TableRow key={q.id}>
                          <TableCell className={css.tableCell}>{q.question}</TableCell>
                          <TableCell className={css.tableCell}>
                            <Mutation
                              mutation={deleteQuestionMutation}
                              refetchQueries={[
                                {
                                  query: getStationQuestions,
                                  variables: {
                                    stationId: station.id,
                                  },
                                },
                              ]}
                            >
                              {(onMutate) => (
                                <DeleteButton
                                  onClick={() =>
                                    onMutate({
                                      variables: {
                                        id: q.id,
                                      },
                                    })
                                  }
                                />
                              )}
                            </Mutation>
                          </TableCell>
                          <TableCell className={css.tableCell}>
                            <Mutation mutation={updateQuestionMutation}>
                              {(onMutate) => (
                                <Switch
                                  checked={q.active}
                                  color='primary'
                                  onChange={() => toggleActiveStatus(q, onMutate)}
                                />
                              )}
                            </Mutation>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )
                }}
              </Query>
            </Table>
          </Paper>
        </div>
      )}
    </StationPage>
  )
}

export default StationFeelingsMeterQuestionsPage
